import React from "react"

import BoardPage from "../components/BoardPage"

import mediumImg from "../imgs/boards/symbiosis_board_medium.jpg"
import largeImg from "../imgs/boards/symbiosis_board_large.jpg"

export const query = graphql`
  query SymbiosisImageQuery {
    file(relativePath:{eq:"imgs/boards/symbiosis_board_medium.jpg"}) {
      childImageSharp {
        sizes(maxWidth: 750, quality: 90) {
          ...GatsbyImageSharpSizes_tracedSVG
        }
		  }
		}
  }
`

export default ({data}) =>
	<BoardPage
		imgSizes={data.file.childImageSharp.sizes}
		downloads={{ med: mediumImg, lrg: largeImg }}
		title="Symbosis"
	/>



// WEBPACK FOOTER //
// ./src/pages/symbiosis.js